/* eslint jsx-a11y/no-static-element-interactions: "off" */

import React from 'react'
import PropTypes from 'prop-types'
import ChevronRight from '../../../static/images/2023-ui/icons/ChevronRight.svg'

import './_leftnavpane.less'

const STORAGE_KEY = 'left-nav-collapsed'

class LeftNavPane extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            toggled: false,
            collapsed: false,
        }
        this.handleToggleCollapse = this.handleToggleCollapse.bind(this)
    }

    safeReadCollapsedPreference() {
        try {
            if (window.sessionStorage) {
                return window.sessionStorage.getItem(STORAGE_KEY) === 'true'
            }
            return false
        } catch (_error) {
            return false
        }
    }

    safeWriteCollapsedPreference(value) {
        try {
            if (window.sessionStorage) {
                window.sessionStorage.setItem(STORAGE_KEY, String(value))
            }
        } catch (_error) {
            // Ignore storage failures (private mode / blocked storage)
        }
    }

    componentDidMount() {
        if (this.safeReadCollapsedPreference()) {
            this.setState({ collapsed: true })
        }
    }

    handleToggleCollapse() {
        this.setState((prevState) => {
            const newCollapsed = !prevState.collapsed
            this.safeWriteCollapsedPreference(newCollapsed)
            return { collapsed: newCollapsed }
        })
    }

    render() {
        const { collapsed } = this.state
        const className = `left-nav-pane${collapsed ? ' left-nav-pane--collapsed' : ''} ${this.props.className || ''}`

        return (
            <div className={className} data-hook='left-nav-pane'>
                <button
                    className='left-nav-pane__toggle'
                    type='button'
                    onClick={this.handleToggleCollapse}
                    aria-expanded={!collapsed}
                    aria-label={collapsed ? 'Show nav' : undefined}
                >
                    <ChevronRight />
                    {!collapsed && 'Hide nav'}
                </button>
                {!collapsed && <span className='left-nav-pane__content'>{this.props.children}</span>}
            </div>
        )
    }
}

export default LeftNavPane

LeftNavPane.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
}
